import React, { Component } from 'react';
import './motorDC.scss';
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';

export class MotorDCElement extends Component {
  constructor(props) {
    super(props);
    this.direction = props.direction || false;
    this.speed = props.speed || 0;
    this.angle = 0;
    this.angleSpeedFactor = 2; // Higher makes wheel spin slower
    this.state = {
      rotation: props.rotation || 0,
      id: props.id || '',
      sliderOpen: true,
    }

    this.render = this.render.bind(this);
  }

  componentDidUpdate = (newProps) => {
    this.direction = newProps.direction;
    this.speed = newProps.speed;
    // console.log('===============', this.id, this.direction, this.speed);
    if (this.direction) {
      this.angle += this.speed / this.angleSpeedFactor;
      if (this.angle > 360) { 
        this.angle = this.angle % 360;
      }
    } else {
      this.angle -= this.speed / this.angleSpeedFactor;
      if (this.angle < 0) { 
        this.angle = this.angle % 360;
      }
    }
  }

  handleRotation = (e) => {
    const { rotation, id } = this.state;
    const newRotation = ((rotation - 90) < -270) ? 0 : rotation - 90;
    this.setState({ rotation: newRotation });
    const rotationEvent = new CustomEvent('component-rotation', { detail: { rotation: newRotation, component: id } });
    document.dispatchEvent(rotationEvent);
  }

  openSlider = (e) => {
    const { id, sliderOpen } = this.state;
    setTimeout(() => {
      if (!document.querySelector(`#${id}`).closest(".react-draggable").classList.contains("react-draggable-dragging")) {
        this.setState({ sliderOpen: !sliderOpen });
      }
    }, 100);
  }

  wheelPath = () => {
    return 'M52.6884 59.3554L48.3718 5.19105C48.3718 2.32573 45.7693 0 42.5575 0C39.3457 0 36.7431 2.32573 36.7431 5.19105L32.4266 59.3554C32.3596 59.7786 32.3254 60.2062 32.3242 60.6346C32.3242 65.6815 36.9059 69.7724 42.5579 69.7724C48.2099 69.7724 52.7916 65.6815 52.7916 60.6346C52.7905 60.2062 52.7553 59.7786 52.6884 59.3554ZM42.5577 10.6989C43.1096 10.6989 43.6492 10.8626 44.1082 11.1692C44.5672 11.4759 44.9249 11.9118 45.1361 12.4218C45.3474 12.9317 45.4026 13.4929 45.2949 14.0343C45.1873 14.5757 44.9214 15.073 44.5311 15.4633C44.1408 15.8536 43.6435 16.1194 43.1021 16.2271C42.5608 16.3348 41.9996 16.2795 41.4896 16.0683C40.9796 15.857 40.5438 15.4993 40.2371 15.0404C39.9304 14.5814 39.7667 14.0418 39.7667 13.4898C39.7667 12.7496 40.0608 12.0397 40.5842 11.5163C41.1076 10.9929 41.8175 10.6989 42.5577 10.6989ZM42.5577 19.3041C43.1096 19.3041 43.6492 19.4678 44.1082 19.7745C44.5672 20.0812 44.9249 20.517 45.1361 21.027C45.3474 21.537 45.4026 22.0981 45.2949 22.6395C45.1873 23.1809 44.9214 23.6782 44.5311 24.0685C44.1408 24.4588 43.6435 24.7246 43.1021 24.8323C42.5608 24.94 41.9996 24.8848 41.4896 24.6735C40.9796 24.4623 40.5438 24.1046 40.2371 23.6456C39.9304 23.1866 39.7667 22.647 39.7667 22.095C39.7667 21.3548 40.0608 20.645 40.5842 20.1216C41.1076 19.5982 41.8175 19.3041 42.5577 19.3041ZM42.5577 27.6768C43.1096 27.6768 43.6492 27.8405 44.1082 28.1471C44.5672 28.4538 44.9249 28.8897 45.1361 29.3997C45.3474 29.9096 45.4026 30.4708 45.2949 31.0122C45.1873 31.5536 44.9214 32.0509 44.5311 32.4412C44.1408 32.8315 43.6435 33.0973 43.1021 33.205C42.5608 33.3127 41.9996 33.2574 41.4896 33.0462C40.9796 32.8349 40.5438 32.4772 40.2371 32.0182C39.9304 31.5593 39.7667 31.0197 39.7667 30.4677C39.7667 29.7275 40.0608 29.0176 40.5842 28.4942C41.1076 27.9708 41.8175 27.6768 42.5577 27.6768ZM42.5577 36.282C43.1096 36.282 43.6492 36.4457 44.1082 36.7524C44.5672 37.059 44.9249 37.4949 45.1361 38.0049C45.3474 38.5149 45.4026 39.076 45.2949 39.6174C45.1873 40.1588 44.9214 40.6561 44.5311 41.0464C44.1408 41.4367 43.6435 41.7025 43.1021 41.8102C42.5608 41.9179 41.9996 41.8627 41.4896 41.6514C40.9796 41.4402 40.5438 41.0825 40.2371 40.6235C39.9304 40.1645 39.7667 39.6249 39.7667 39.0729C39.7667 38.3327 40.0608 37.6229 40.5842 37.0995C41.1076 36.5761 41.8175 36.282 42.5577 36.282ZM48.479 65.6932C47.3079 66.8638 45.8161 67.661 44.192 67.9838C42.5679 68.3066 40.8846 68.1407 39.3549 67.5069C37.8251 66.8731 36.5177 65.8 35.5978 64.4231C34.6779 63.0463 34.1869 61.4277 34.1869 59.7718C34.1869 58.116 34.6779 56.4973 35.5978 55.1205C36.5177 53.7437 37.8251 52.6706 39.3549 52.0368C40.8846 51.403 42.5679 51.237 44.192 51.5599C45.8161 51.8827 47.3079 52.6798 48.479 53.8505C49.2567 54.628 49.8737 55.5511 50.2946 56.5671C50.7156 57.5831 50.9322 58.6721 50.9322 59.7718C50.9322 60.8716 50.7156 61.9605 50.2946 62.9765C49.8737 63.9925 49.2567 64.9157 48.479 65.6932Z';
  }

  render = () => {
    const { id, sliderOpen, rotation } = this.state;
    return (
      <div className="motorPWM" id={id}>
        <div className={`rotation${sliderOpen ? ' open' : ''}${(rotation === -90 || rotation === -270) ? ' rotate_90' : ''}`} onClick={this.handleRotation}><ScreenRotationIcon fontSize="inherit" htmlColor="white" /></div>
        <svg
          id="Capa_2"
          data-name="Capa 2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-41 -40 160 160"
          width="30mm"
          height="30mm"
          transform={`translate(0 0) rotate(${rotation})`}
        >

          <filter id="ledFilter" x="-0.8" y="-0.8" height="2.2" width="2.8">
            <feGaussianBlur stdDeviation="4" />
          </filter>

          <g id="capa-led" data-name="Capa 1" onMouseDown={this.openSlider}>
            <g>
              <g id="ARC">
                <path className="cls-led-10" d="m1.2,4.42s0,0,0,0c0-2.35,1.91-4.25,4.25-4.25h46.45c.8,0,1.45.64,1.45,1.44v2.78c0,2.5,2.03,4.53,4.54,4.54,2.5,0,4.53-2.03,4.54-4.53,0,0,0,0,0,0V1.58c0-.78.63-1.42,1.42-1.42h46.5c2.35,0,4.25,1.91,4.25,4.25v48.19s0,0,0,0c0,2.35-1.91,4.25-4.25,4.25h-46.49c-.78,0-1.42-.64-1.42-1.42v-2.81c0-2.51-2.03-4.54-4.54-4.54-2.5,0-4.53,2.03-4.54,4.54v2.78s0,0,0,0c0,.8-.65,1.44-1.45,1.44H5.45c-2.35,0-4.25-1.9-4.25-4.25" />
              </g>

              <path
                transform={`translate(42 25) rotate(${this.angle || 0}) translate(-42.6 -59.6)`}
                d={this.wheelPath()}
                fill="#cacaca"
              />
              <path
                transform={`translate(42 25) rotate(${(this.angle || 0) + 90}) translate(-42.6 -59.6)`}
                d={this.wheelPath()}
                fill="#cacaca"
              />
              <path
                transform={`translate(42 25) rotate(${(this.angle || 0) + 180}) translate(-42.6 -59.6)`}
                d={this.wheelPath()}
                fill="#cacaca"
              />
              <path
                transform={`translate(42 25) rotate(${(this.angle || 0) + 270}) translate(-42.6 -59.6)`}
                d={this.wheelPath()}
                fill="#cacaca"
              />

            </g>
          </g>
        </svg>
      </div>
    );
  }
}
